import { Injectable } from "@angular/core";
import { DEFAULT_PAGE_SIZE } from "../../constant/tables";
import { TableColumn, TableState, TableStates } from "../../models/common-table";

@Injectable({
  providedIn: "root",
})
export class CommonTablePersistenceService {
  public getTableState(tableName: string): TableState {
    const defaultTableState: TableState = {
      pageNumber: 0,
      pageSize: DEFAULT_PAGE_SIZE,
      filterItems: [],
      selectedColumns: [],
    };

    if (tableName === "csp-table") {
      return defaultTableState;
    }

    try {
      const pageUrl: string = this.getCurrentPageUrl();
      const tableStates: TableStates = this.readTableStates();
      const storedTableState: TableState | undefined = tableStates?.[pageUrl]?.[tableName];

      if (!storedTableState) {
        return defaultTableState;
      }

      return {
        ...defaultTableState,
        ...storedTableState,
      };
    } catch {
      localStorage.setItem("tableStates", "{}");
      return defaultTableState;
    }
  }

  public setTableState(
    tableName: string,
    currentPageSize: number,
    selectedColumns: Partial<TableColumn>[],
    updates: Partial<TableState>,
  ): void {
    if (tableName === "csp-table") {
      return;
    }

    try {
      const pageUrl: string = this.getCurrentPageUrl();
      const tableStates: TableStates = this.readTableStates();

      if (!tableStates[pageUrl]) {
        tableStates[pageUrl] = {};
      }

      if (!tableStates[pageUrl][tableName]) {
        tableStates[pageUrl][tableName] = {
          pageSize: currentPageSize,
          pageNumber: 0,
          filterItems: [],
          selectedColumns,
        };
      }

      tableStates[pageUrl][tableName] = {
        ...tableStates[pageUrl][tableName],
        ...updates,
      };
      localStorage.setItem("tableStates", JSON.stringify(tableStates));
    } catch {
      localStorage.setItem("tableStates", "{}");
    }
  }

  private getCurrentPageUrl(): string {
    const urlWithHash: string = `${location.pathname}${location.hash}`;

    if (urlWithHash === "/dashboard#services" || urlWithHash === "/dashboard#tenancies") {
      return "/dashboard#change-approvals";
    }

    return urlWithHash;
  }

  private readTableStates(): TableStates {
    const persistedState: string | null = localStorage.getItem("tableStates");
    if (!persistedState) {
      return {};
    }

    const parsedState: unknown = JSON.parse(persistedState);
    if (!parsedState || typeof parsedState !== "object") {
      return {};
    }

    return parsedState as TableStates;
  }
}
